import React from "react";
import { save } from "../shared/stamps";

// Bulk is the dollar-and-under end of a stack. Buying it barely moves the
// number — 80% of a $1 card is 80c — so it mostly gets in the way of the
// cards the deal actually turns on. $5 is the default line; it's a text box
// because where bulk starts depends on who you're dealing with.
export const BULK_DEFAULT = 5;
export const BULK_STORAGE_KEY = "ppt_bulk_filter_v1";

export function loadBulkPref() {
  try {
    const raw = window.localStorage.getItem(BULK_STORAGE_KEY);
    if (!raw) return { hide: false, under: BULK_DEFAULT };
    const parsed = JSON.parse(raw);
    const under = Number(parsed?.under);
    return {
      hide: parsed?.hide === true,
      under: Number.isFinite(under) && under >= 0 ? under : BULK_DEFAULT,
    };
  } catch {
    return { hide: false, under: BULK_DEFAULT };
  }
}

export function saveBulkPref(pref) {
  try {
    save(BULK_STORAGE_KEY, JSON.stringify(pref));
  } catch {
    /* a blocked localStorage shouldn't break the toggle */
  }
}

/** A card counts as bulk when it has a price and that price is under the line.
 *  An unpriced card is never bulk — we don't know what it's worth, and hiding
 *  it on a guess is how you leave money on the table. */
export const isBulk = (price, under) => {
  const n = Number(price);
  return Number.isFinite(n) && n > 0 && n < under;
};

export default function BulkFilter({ hide, under, onChange, hiddenCount = 0, hiddenValue = null }) {
  return (
    <span className="bulk-filter">
      <label className="check-inline">
        <input
          type="checkbox"
          checked={hide}
          onChange={(e) => onChange({ hide: e.target.checked, under })}
        />
        Hide bulk under
      </label>
      <span className="bulk-under">
        $
        <input
          className="bulk-under-input"
          type="text"
          inputMode="decimal"
          value={under}
          onChange={(e) => {
            const v = e.target.value.replace(/[^\d.]/g, "");
            onChange({ hide, under: v === "" ? 0 : Number(v) });
          }}
          onBlur={() => { if (!under) onChange({ hide, under: BULK_DEFAULT }); }}
          aria-label="Bulk threshold in dollars"
          size={4}
        />
      </span>
      {/* Never hide silently: say how much was set aside, so the number you
          offer on is one you chose rather than one the filter chose. */}
      {hide && hiddenCount > 0 && (
        <span className="bulk-note">
          {hiddenCount} hidden
          {hiddenValue != null && ` · $${hiddenValue.toFixed(2)}`}
        </span>
      )}
    </span>
  );
}
